module.exports = __webpack_public_path__ + "img/Icon-sidebar-Settings.745d427c.svg";